<template>
  <VRow 
    v-bind="$props"
    class="w-row"
  >
    <slot />
  </VRow>
</template>

<script>
import { VRow } from 'vuetify/lib';

export default {
  props: {
    ...VRow.options.props
  },
  components: { VRow }
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles';

$dense-padding: calc(#{$spacer} * 2);
$dense-mobile-padding: calc(#{$spacer *0.75});

/* ### OVERRIDES VUETIFY DEFAULT SELECTORS ### */
.row--dense {
  margin: 0 calc(#{$dense-padding} * -1);
}

.row--dense > .col, .row--dense > [class*=col-] {
  padding: $dense-padding;
}
.row--dense>.col, .row--dense>[class*=col-] {
  padding: $dense-padding;
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .row + .row {
    margin-top: 0!important;
  }
  .row--dense, .row {
    margin: 0 calc(#{$dense-padding} * -1);
  }
  
  .row > .w-col {
    padding: $dense-mobile-padding 0.5rem;
  }
  
}
</style>
